import React from 'react';
import MuiAlert from '@material-ui/lab/Alert';
import { Snackbar, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  snackbarRoot: {
    zIndex: '99999999 !important',
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const UIDialogConfirm = ({ ...children }) => {
  const classes = useStyles();

  const getErrorMessage = () => {
    if (!children.data || !children.data.error) {
      return children.messageError || 'Ocorreu um erro ao processar a solicitação.';
    }
    const errRes = children.data.error.response;
    if (errRes && errRes.data) {
      if (typeof errRes.data.error === 'string') return errRes.data.error;
      if (typeof errRes.data.message === 'string') return errRes.data.message;
    }
    return children.messageError || children.data.error.message || 'Ocorreu um erro no servidor.';
  };

  return (
    <>
      {children.data && children.data.data && (
        <Snackbar
          className={classes.snackbarRoot}
          open={children.open}
          autoHideDuration={children.timeSucess ? children.timeSucess : 5000}
          onClose={children.close}
          onExited={children.setrequestinfo}
        >
          <Alert onClose={children.close} severity="success">
            {children.messageSucess}
          </Alert>
        </Snackbar>
      )}
      {children.data && children.data.error && (
        <Snackbar
          className={classes.snackbarRoot}
          open={children.open}
          autoHideDuration={6000}
          onClose={children.close}
          onExited={children.setrequestinfo}
        >
          <Alert onClose={children.close} severity="error">
            {getErrorMessage()}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default UIDialogConfirm;
